import { Routes } from '@angular/router'
import { AppAuthService } from './shared/services/app-auth.service'
import EditProjectDeactivateGuard from './features/feature-edit-project/edit-project-deactivate.guard'
import { FeatureEditProjectComponent } from './features/feature-edit-project/feature-edit-project.component'
import { FEATURE_EDIT_PROJECT_ROUTES } from './features/feature-edit-project/feature-edit-project.routes'
import { AppCanOpenEditGuard } from './shared/services/guards/app-can-open-edit.guard.service'
import { AppIsActualCostGuard, AppIsLumpSumGuard } from './shared/services/guards/app-is-lump-sum.guard.service'

export const routes: Routes = [
   {
      path: '',
      redirectTo: '/error',
      pathMatch: 'full'
   },
   {
      path: ':projectId/dashboard',
      data: { preloadGroup: 'dashboard' },
      canActivate: [AppAuthService],
      loadComponent: () => import('./features/feature-dashboard/feature-dashboard.component').then((m) => m.FeatureDashboardComponent)
   },
   {
      path: ':projectId/edit-project',
      canActivate: [AppAuthService, AppCanOpenEditGuard],
      canDeactivate: [EditProjectDeactivateGuard],
      component: FeatureEditProjectComponent,
      children: FEATURE_EDIT_PROJECT_ROUTES
   },
   {
      path: ':projectId/partners',
      data: { preloadGroup: 'partners' },
      canActivate: [AppAuthService],
      loadComponent: () => import('./features/feature-partners/feature-partners.component').then((m) => m.FeaturePartnersComponent)
   },
   {
      path: ':projectId/calendar',
      data: { preloadGroup: 'calendar' },
      canActivate: [AppAuthService],
      loadChildren: () => import('./features/feature-calendar/feature-calendar.routes').then((m) => m.FEATURE_CALENDAR_ROUTES)
   },
   {
      path: ':projectId/doodles',
      data: { preloadGroup: 'doodles' },
      canActivate: [AppAuthService],
      loadChildren: () => import('./features/feature-doodles/feature-doodles.routes').then((m) => m.FEATURE_DOODLES_ROUTES)
   },
   {
      path: ':projectId/mailing-list',
      data: { preloadGroup: 'mailing-list' },
      canActivate: [AppAuthService],
      loadComponent: () => import('./features/feature-mailing-list/feature-mailing-list.component').then((m) => m.FeatureMailingListComponent)
   },
   {
      path: ':projectId/budget',
      data: { preloadGroup: 'budget' },
      canActivate: [AppAuthService, AppIsActualCostGuard],
      loadChildren: () => import('./features/feature-budget/feature-budget.routes').then((m) => m.FEATURE_BUDGET_ROUTES)
   },
   {
      path: ':projectId/lump-sum',
      data: { preloadGroup: 'lump-sum' },
      canActivate: [AppAuthService, AppIsLumpSumGuard],
      loadChildren: () => import('./features/feature-lump-sum/feature-lump-sum.routes').then((m) => m.FEATURE_LUMP_SUM_ROUTES)
   },
   {
      path: ':projectId/wbs',
      data: { preloadGroup: 'wbs' },
      canActivate: [AppAuthService],
      loadChildren: () => import('./features/feature-wbs/feature-wbs.routes').then((m) => m.FEATURE_WBS_ROUTES)
   },
   {
      path: 'error',
      loadComponent: () => import('./core/pages/private/error-page/error-page.component').then((m) => m.ErrorPageComponent)
   },
   { path: '**', redirectTo: '/error' }
]
